/**
 * CSV cells that are inert in Excel/Sheets/LibreOffice (spec 2026-11-03 §4.3).
 * Same rule as the backend's csvSafeCell: a value that would be read as a
 * formula (leading = + - @ tab CR after optional whitespace) is prefixed with an
 * apostrophe, except number-like values (phones such as +234…, negative or
 * grouped amounts) where the apostrophe would show literally and nothing can
 * execute anyway. Plain TypeScript with no imports so Node can run the tests
 * directly (`yarn test`).
 */
export const FORMULA_LEAD_RE = /^\s*[=+\-@\t\r]/;
export const NUMBER_LIKE_RE = /^\s*[+-]?\d[\d .,()-]*$/;

export function csvSafeCell(v: unknown): string {
  if (v === null || v === undefined) return '';
  let s: string;
  if (v instanceof Date) s = v.toISOString();
  else if (typeof v === 'object') s = JSON.stringify(v);
  else s = String(v);
  if (FORMULA_LEAD_RE.test(s) && !NUMBER_LIKE_RE.test(s)) return `'${s}`;
  return s;
}

/** One RFC 4180 row: every cell quoted, inner quotes doubled, formula-safe. */
export function toCsvRow(values: unknown[]): string {
  return values.map((v) => `"${csvSafeCell(v).replace(/"/g, '""')}"`).join(',');
}

export function toCsv(header: string[], rows: unknown[][]): string {
  return [toCsvRow(header), ...rows.map(toCsvRow)].join('\n');
}
